import { render, staticRenderFns } from "./audit-logs.vue?vue&type=template&id=42fd50ee&scoped=true"
import script from "./audit-logs.vue?vue&type=script&lang=js"
export * from "./audit-logs.vue?vue&type=script&lang=js"
import style0 from "./audit-logs.vue?vue&type=style&index=0&id=42fd50ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd50ee",
  null
  
)

export default component.exports